// extracted by mini-css-extract-plugin
export default {"followButton":"oS-z","followCount":"pS-z","textStyle":"qS-z"};